// extracted by mini-css-extract-plugin
export var chevronIcon = "_6r-2";
export var teamName = "_6r-1";
export var teamSwitcherButton = "_6r-0";